import { forwardRef } from "react";
import ReactPlayer from "react-player/lazy";
import usePlayer from "src/hooks/usePlayer";

const AfricastPlayer = forwardRef(({ width, height, onReady }, ref) => {
  const { playerState, setPlayerState, videoData } = usePlayer();

  const handleProgress = (state) => {
    if (!playerState.seeking) {
      setPlayerState({
        ...state,
        duration: state.loadedSeconds / state.loaded,
      });
    }
  };

  return (
    <ReactPlayer
      style={{ margin: "auto", verticalAlign: "middle" }}
      ref={ref}
      width={width}
      height={height}
      url={videoData.video}
      // url="https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8"
      pip={false}
      controls={false}
      light={playerState.light}
      loop={playerState.loop}
      muted={playerState.muted}
      volume={playerState.volume}
      playing={playerState.playing}
      onReady={onReady}
      onProgress={handleProgress}
      playbackRate={playerState.playbackRate}
      onError={(e) => console.log("onError", e)}
    />
  );
});

export default AfricastPlayer;
